import { createFileRoute, notFound } from "@tanstack/react-router";
import { createServerFn } from "@tanstack/react-start";
import { getRequestHeaders } from "@tanstack/react-start/server";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";

import { isOperatorLoopbackSafeBoundaryRequest } from "@/integrations/multiresume/operator/loopback-test-fault";

const searchSchema = z.object({ mode: z.enum(["error", "not-found"]).catch("error") });

const authorizeBoundaryFixture = createServerFn({ method: "GET" }).handler(() =>
  isOperatorLoopbackSafeBoundaryRequest(getRequestHeaders()),
);

export const Route = createFileRoute("/dev/phase6-safe-boundary/$family")({
  component: () => null,
  validateSearch: zodValidator(searchSchema),
  loaderDeps: ({ search }) => search,
  loader: async ({ deps }) => {
    if (!(await authorizeBoundaryFixture())) throw notFound();
    if (deps.mode === "not-found") throw notFound();
    throw new Error("PHASE6_PRIVATE_ROUTE_STACK_AND_DATABASE_SECRET_SENTINEL");
  },
});
